var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2135_19483)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.58138 15.6769C3.40609 15.6769 3.23201 15.6222 3.08345 15.5148C2.80671 15.3142 2.67743 14.9695 2.75275 14.6368L3.78207 10.1027L0.291261 7.04131C0.0346623 6.8173 -0.0633627 6.46256 0.0419867 6.13797C0.147336 5.81398 0.433965 5.58461 0.773329 5.55323L5.3921 5.13391L7.2182 0.860487C7.35284 0.546514 7.65949 0.34375 8.0002 0.34375C8.34091 0.34375 8.64755 0.546514 8.7822 0.859754L10.6083 5.13391L15.2263 5.55323C15.5664 5.58387 15.8531 5.81398 15.9584 6.13797C16.0638 6.46195 15.9663 6.8173 15.7097 7.04131L12.2189 10.1021L13.2483 14.6361C13.3237 14.9695 13.1943 15.3142 12.9177 15.5142C12.6417 15.7141 12.2736 15.7295 11.983 15.5548L8.0002 13.1748L4.01743 15.5562C3.88278 15.6361 3.73276 15.6769 3.58138 15.6769ZM8.0002 12.1495C8.15157 12.1495 8.30148 12.1901 8.43625 12.2701L12.195 14.5182L11.2235 10.2387C11.1542 9.93408 11.2576 9.61608 11.493 9.41002L14.7891 6.51932L10.4282 6.12332C10.1143 6.09463 9.84424 5.89724 9.72156 5.60792L8.0002 1.5751L6.27677 5.60853C6.15543 5.89589 5.8854 6.09329 5.57216 6.12197L1.21072 6.51798L4.5067 9.40868C4.74279 9.61535 4.84607 9.93274 4.77612 10.238L3.80539 14.5175L7.56415 12.2701C7.6988 12.1901 7.84883 12.1495 8.0002 12.1495ZM5.35682 5.21656C5.35682 5.21656 5.35682 5.21729 5.35609 5.2179L5.35682 5.21656ZM10.6422 5.2146L10.643 5.21595C10.643 5.21521 10.643 5.21521 10.6422 5.2146Z",
    fill: "#00A094"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2135_19483"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarEmpty);
export default __webpack_public_path__ + "static/media/starEmpty.0835276855c67fc102de7c872ecab51d.svg";
export { ForwardRef as ReactComponent };